import axios from 'axios';
import { MutationCache, QueryClient } from 'react-query';

const mutationCache = new MutationCache({
  onError: (error, _variables, _context, mutation) => {
    const mutationKey = mutation.options.mutationKey ? [mutation.options.mutationKey].flat().join('.') : undefined;

    console.error('[React Query error]:', error, mutationKey ? `Mutation: ${mutationKey}` : '');
  },
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      onError: error => {
        if (axios.isAxiosError(error)) {
          console.error(`[React Query error]: ${error.message}. URL: ${axios.getUri(error.config)}`);
        } else {
          console.error('[React Query error]:', error);
        }
      },
    },
  },
  mutationCache,
});
